import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04dea360&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=04dea360&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=04dea360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dea360",
  null
  
)

export default component.exports